import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Home from "../pages/home/page";
import Register from "../pages/register/page";
import AdminDashboard from "../pages/admin/page";
import AddChurchPage from "../pages/add-church/page";
import VendorDashboard from "../pages/vendor/page";
import OrganizerDashboard from "../pages/organizer/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import PaymentReturnPage from "../pages/payment-return/page";
import PrivacyPage from "../pages/legal/privacy";
import TermsPage from "../pages/legal/terms";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/payment/success", element: <PaymentReturnPage /> },
  { path: "/payment/cancel", element: <PaymentReturnPage /> },
  { path: "/add-church", element: <ProtectedRoute role="admin"><AddChurchPage /></ProtectedRoute> },
  { path: "/admin", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/products", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/events", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/lieux", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/eglises", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/finance-products", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/finance-events", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/finance-lieux", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/messe-payments", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/users", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/logs", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/app-content", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/admin/profile", element: <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute> },
  { path: "/vendor", element: <ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute> },
  { path: "/vendor/products", element: <ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute> },
  { path: "/vendor/orders", element: <ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute> },
  { path: "/vendor/notifications", element: <ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute> },
  { path: "/vendor/profile", element: <ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute> },
  { path: "/organizer", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "/organizer/events", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "/organizer/tickets", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "/organizer/finances", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "/organizer/notifications", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "/organizer/profile", element: <ProtectedRoute role="organizer"><OrganizerDashboard /></ProtectedRoute> },
  { path: "*", element: <NotFound /> },
];

export default routes;
